import React from 'react';
import styled from '@emotion/styled/macro';
import vars from '@variables';
import { IconProps } from '../icon-atoms/icon-atoms.types';

// New EMF Logo with smaller text
const EMFLogo: React.FC<IconProps> = ({
  width = '216',
  height = '36',
  fill = vars.coreDarkGrey,
  className,
}) => (
  <svg
    width="200"
    height="42"
    viewBox="0 0 200 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-label="EMF logo"
    data-testid="logo-atom"
  >
    <path
      d="M47.8867 8.97656H56.3026V11.4342H50.7564V13.0138H55.7793V15.291H50.7564V16.9428H56.375V19.4004H47.8867V8.97656Z"
      fill={fill}
    />
    <path
      d="M57.7559 8.97656H60.6537V16.8666H65.7209V19.3964H57.7559V8.97656Z"
      fill={fill}
    />
    <path
      d="M66.8438 8.97656H69.7416V16.8666H74.8088V19.3964H66.8438V8.97656Z"
      fill={fill}
    />
    <path
      d="M75.9316 8.97656H84.3475V11.4342H78.8013V13.0138H83.8243V15.291H78.8013V16.9428H84.4199V19.4004H75.9316V8.97656Z"
      fill={fill}
    />
    <path
      d="M85.7852 8.97656H88.4898L92.7963 14.4852V8.97656H95.666V19.4004H93.1264L88.6589 13.6833V19.4004H85.7892V8.97656H85.7852Z"
      fill={fill}
    />
    <path
      d="M101.662 8.97656H104.725L107.221 13.0098L109.716 8.97656H112.779V19.4004H109.893V13.4147L107.217 17.496H107.156L104.496 13.4468V19.4004H101.654V8.97656H101.662Z"
      fill={fill}
    />
    <path
      d="M118.135 8.9043H120.928L125.384 19.4003H122.277L121.516 17.54H117.479L116.73 19.4003H113.68L118.135 8.9043ZM120.675 15.2909L119.508 12.3281L118.328 15.2909H120.675Z"
      fill={fill}
    />
    <path
      d="M125.135 14.2199V14.1919C125.135 11.1529 127.481 8.77148 130.649 8.77148C132.786 8.77148 134.162 9.66553 135.088 10.9445L132.907 12.6283C132.307 11.8826 131.623 11.4055 130.621 11.4055C129.156 11.4055 128.125 12.6403 128.125 14.1598V14.1879C128.125 15.7514 129.156 16.9702 130.621 16.9702C131.711 16.9702 132.355 16.4651 132.983 15.7033L135.165 17.2509C134.178 18.606 132.846 19.6042 130.532 19.6042C127.542 19.6042 125.135 17.327 125.135 14.2159V14.2199Z"
      fill={fill}
    />
    <path
      d="M139.637 8.9043H142.43L146.886 19.4003H143.779L143.018 17.54H138.981L138.232 19.4003H135.182L139.637 8.9043ZM142.177 15.2909L141.01 12.3281L139.83 15.2909H142.177Z"
      fill={fill}
    />
    <path
      d="M147.682 8.97656H152.628C154.226 8.97656 155.333 9.39352 156.037 10.1071C156.649 10.7045 156.963 11.5063 156.963 12.5327V12.5608C156.963 14.1524 156.11 15.2108 154.81 15.7601L157.305 19.3924H153.956L151.847 16.2372H150.576V19.3924H147.678V8.97656H147.682ZM152.495 13.98C153.481 13.98 154.049 13.5029 154.049 12.7452V12.7171C154.049 11.8992 153.449 11.4823 152.479 11.4823H150.58V13.984H152.491L152.495 13.98Z"
      fill={fill}
    />
    <path
      d="M160.758 11.5103H157.619V8.98047H166.796V11.5103H163.656V19.4003H160.758V11.5103Z"
      fill={fill}
    />
    <path
      d="M167.846 8.97656H170.744V12.8775H174.466V8.97656H177.364V19.4004H174.466V15.4393H170.744V19.4004H167.846V8.97656Z"
      fill={fill}
    />
    <path
      d="M179.059 14.8298V8.98047H182.005V14.7737C182.005 16.2771 182.765 16.9908 183.933 16.9908C185.1 16.9908 185.86 16.3052 185.86 14.8459V8.98047H188.807V14.7577C188.807 18.1214 186.879 19.5967 183.904 19.5967C180.93 19.5967 179.063 18.0933 179.063 14.8338L179.059 14.8298Z"
      fill={fill}
    />
    <path
      d="M190.377 8.97656H195.324C196.921 8.97656 198.028 9.39352 198.733 10.1071C199.344 10.7045 199.658 11.5063 199.658 12.5327V12.5608C199.658 14.1524 198.805 15.2108 197.505 15.7601L200 19.3924H196.652L194.543 16.2372H193.271V19.3924H190.373V8.97656H190.377ZM195.191 13.98C196.177 13.98 196.744 13.5029 196.744 12.7452V12.7171C196.744 11.8992 196.145 11.4823 195.175 11.4823H193.275V13.984H195.187L195.191 13.98Z"
      fill={fill}
    />
    <path
      d="M47.8867 22.7442H56.2583V25.274H50.7886V27.0461H55.7351V29.4436H50.7886V33.1641H47.8907V22.7402L47.8867 22.7442Z"
      fill={fill}
    />
    <path
      d="M56.875 27.9875V27.9595C56.875 24.9686 59.2979 22.5391 62.5258 22.5391C65.7537 22.5391 68.1444 24.9365 68.1444 27.9274V27.9554C68.1444 30.9463 65.7215 33.3758 62.4936 33.3758C59.2657 33.3758 56.875 30.9784 56.875 27.9875ZM65.1862 27.9875V27.9595C65.1862 26.456 64.0955 25.145 62.4936 25.145C60.8917 25.145 59.8493 26.4239 59.8493 27.9274V27.9554C59.8493 29.4589 60.94 30.7699 62.5258 30.7699C64.1116 30.7699 65.1862 29.491 65.1862 27.9875Z"
      fill={fill}
    />
    <path
      d="M69.2949 28.5974V22.748H72.2411V28.5413C72.2411 30.0447 73.0018 30.7584 74.1689 30.7584C75.3361 30.7584 76.0968 30.0728 76.0968 28.6135V22.748H79.043V28.5253C79.043 31.8889 77.1151 33.3643 74.1408 33.3643C71.1665 33.3643 69.2989 31.8609 69.2989 28.6014L69.2949 28.5974Z"
      fill={fill}
    />
    <path
      d="M80.6562 22.7441H83.3609L87.6674 28.2527V22.7441H90.5371V33.168H87.9975L83.53 27.4509V33.168H80.6603V22.7441H80.6562Z"
      fill={fill}
    />
    <path
      d="M92.3926 22.7442H96.4294C100.164 22.7442 102.334 24.8891 102.334 27.896V27.9241C102.334 30.931 100.136 33.1641 96.3691 33.1641H92.3926V22.7402V22.7442ZM96.4737 30.6062C98.2084 30.6062 99.3595 29.652 99.3595 27.9722V27.9441C99.3595 26.2763 98.2084 25.3101 96.4737 25.3101H95.2945V30.6102H96.4737V30.6062Z"
      fill={fill}
    />
    <path
      d="M106.459 22.6719H109.253L113.708 33.1679H110.601L109.84 31.3076H105.803L105.055 33.1679H102.004L106.459 22.6719ZM108.999 29.0585L107.832 26.0957L106.653 29.0585H108.999Z"
      fill={fill}
    />
    <path
      d="M115.52 25.2778H112.381V22.748H121.557V25.2778H118.418V33.1679H115.52V25.2778Z"
      fill={fill}
    />
    <path d="M122.514 22.7441H125.428V33.168H122.514V22.7441Z" fill={fill} />
    <path
      d="M126.584 27.9875V27.9595C126.584 24.9686 129.007 22.5391 132.235 22.5391C135.463 22.5391 137.853 24.9365 137.853 27.9274V27.9554C137.853 30.9463 135.43 33.3758 132.203 33.3758C128.975 33.3758 126.584 30.9784 126.584 27.9875ZM134.895 27.9875V27.9595C134.895 26.456 133.804 25.145 132.203 25.145C130.601 25.145 129.558 26.4239 129.558 27.9274V27.9554C129.558 29.4589 130.649 30.7699 132.235 30.7699C133.821 30.7699 134.895 29.491 134.895 27.9875Z"
      fill={fill}
    />
    <path
      d="M139.064 22.7441H141.769L146.076 28.2527V22.7441H148.945V33.168H146.406L141.938 27.4509V33.168H139.068V22.7441H139.064Z"
      fill={fill}
    />
    <path
      d="M21.0819 42C9.45826 42 0 32.5785 0 21C0 9.42154 9.45826 0 21.0819 0C32.7055 0 42.1637 9.42154 42.1637 21C42.1637 32.5785 32.7055 42 21.0819 42ZM21.0819 2.84651C11.032 2.84651 2.8576 10.9891 2.8576 21C2.8576 31.0109 11.032 39.1535 21.0819 39.1535C31.1318 39.1535 39.3061 31.0109 39.3061 21C39.3061 10.9891 31.1277 2.84651 21.0819 2.84651ZM22.7401 38.5401C14.0506 38.5401 6.97899 31.496 6.97899 22.8402C6.97899 14.1844 14.0465 7.14032 22.7401 7.14032C31.4336 7.14032 38.5012 14.1844 38.5012 22.8402C38.5012 31.496 31.4296 38.5401 22.7401 38.5401ZM22.7401 9.90664C15.58 9.90664 9.7561 15.7079 9.7561 22.8402C9.7561 29.9725 15.58 35.7738 22.7401 35.7738C29.9002 35.7738 35.7241 29.9725 35.7241 22.8402C35.7241 15.7079 29.9002 9.90664 22.7401 9.90664ZM21.0819 31.6163C15.2459 31.6163 10.4967 26.8855 10.4967 21.0722C10.4967 15.2589 15.2459 10.5281 21.0819 10.5281C26.9178 10.5281 31.6671 15.2589 31.6671 21.0722C31.6671 26.8855 26.9178 31.6163 21.0819 31.6163ZM21.0819 13.2142C16.7311 13.2142 13.1933 16.7383 13.1933 21.0722C13.1933 25.4061 16.7311 28.9301 21.0819 28.9301C25.4327 28.9301 28.9705 25.4061 28.9705 21.0722C28.9705 16.7383 25.4327 13.2142 21.0819 13.2142Z"
      fill={fill}
    />
  </svg>
);

export const EMFLogoAtom = styled(EMFLogo)`
  display: flex;
  align-items: center;
`;

const EMFCirclesLogo: React.FC<IconProps> = ({
  width = '36',
  height = '36',
  fill,
  className,
}) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 36 36"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    aria-label="EMF Circles logo"
  >
    <path
      d="M18 36C8.07457 36 0 27.9246 0 17.9982C0 8.07536 8.07457 0 18 0C27.9254 0 36 8.07536 36 17.9982C35.9965 27.9246 27.9219 36 18 36ZM18 2.44098C9.42033 2.44098 2.43721 9.42125 2.43721 17.9982C2.43721 26.5787 9.42033 33.559 17.9965 33.559C26.5726 33.559 33.5557 26.5787 33.5557 17.9982C33.5557 9.42125 26.5761 2.44098 18 2.44098ZM19.4129 33.0362C11.9918 33.0362 5.95526 26.9991 5.95526 19.5773C5.95526 12.159 11.9918 6.11834 19.4129 6.11834C26.834 6.11834 32.8705 12.1554 32.8705 19.5773C32.8705 26.9991 26.834 33.0362 19.4129 33.0362ZM19.4129 8.4922C13.3022 8.4922 8.32889 13.466 8.32889 19.5773C8.32889 25.6921 13.3022 30.6659 19.4129 30.6659C25.5271 30.6659 30.5004 25.6921 30.5004 19.5773C30.5004 13.466 25.5271 8.4922 19.4129 8.4922ZM17.9965 27.1016C13.0126 27.1016 8.95761 23.0462 8.95761 18.0618C8.95761 13.081 13.0126 9.02561 17.9965 9.02561C22.9804 9.02561 27.0318 13.081 27.0318 18.0618C27.0318 23.0462 22.9804 27.1016 17.9965 27.1016ZM17.9965 11.3288C14.2841 11.3288 11.2606 14.3527 11.2606 18.0654C11.2606 21.778 14.2841 24.8019 17.9965 24.8019C21.7088 24.8019 24.7323 21.778 24.7323 18.0654C24.7323 14.3491 21.7088 11.3288 17.9965 11.3288Z"
      fill={fill}
    />
  </svg>
);

export const EMFCirclesLogoAtom = styled(EMFCirclesLogo)`
  display: flex;
  align-items: center;
`;

const EMFResponsiveLogo: React.FC<IconProps> = ({ fill, className }) => (
  <span className={className}>
    <EMFLogoAtom fill={fill} />
    <EMFCirclesLogoAtom fill={fill} />
  </span>
);

export const EMFResponsiveLogoAtom = styled(EMFResponsiveLogo)`
  ${EMFLogoAtom}, ${EMFCirclesLogoAtom} {
    position: relative;
  }
  ${EMFLogoAtom} {
    display: block;

    @media screen and (min-width: ${vars.breakPointTablet}) {
      display: none;
    }
    @media screen and (min-width: ${vars.breakPointSmallDesktop}) {
      display: block;
    }
  }
  ${EMFCirclesLogoAtom} {
    display: none;

    @media screen and (min-width: ${vars.breakPointTablet}) {
      display: block;
    }
    @media screen and (min-width: ${vars.breakPointSmallDesktop}) {
      display: none;
    }
  }
`;

interface CyberEssentialsLogoProps {
  className?: string;
}

const CyberEssentialsLogo = ({ className }: CyberEssentialsLogoProps) => (
  <div className={className}>
    <a
      href="https://registry.blockmarktech.com/certificates/d1de05b7-93f7-4bdd-b8d6-a840db6af416/"
      target="_blank"
      rel="noreferrer"
    >
      <img
        src="https://images.ctfassets.net/isq5xwjfoz2m/4ff97t8FvbH7U43ECuj7qg/d9d506077bde444ee2e513626eecc34b/Cyber-Essentials-Logo-v2__1_.png"
        alt="Cyber Essentials Certified"
      ></img>
    </a>
  </div>
);

export const CyberEssentialsLogoAtom = styled(CyberEssentialsLogo)`
  margin: 15px 14px 0 0;
  img {
    width: 59px !important;
    height: 70px !important;
  }

  @media screen and (min-width: ${vars.breakPointTablet}) {
    margin: 30px 0 30px 0;
  }

  @media screen and (min-width: ${vars.breakPointSmallDesktop}) {
    margin-bottom: 0;
  }
`;
